<template>
  <!-- system 标准列表：对齐 police-record/index.vue；顶部采集区为业务扩展 -->
  <div>
    <div ref="extraAboveCrud" class="warning-mechanism__collect">
      <div style="display: flex; gap: 12px; align-items: center; flex-wrap: wrap">
        <div style="font-size: 13px; color: #606266">采集工具：</div>
        <el-input
          v-model.trim="collectPointIds"
          size="small"
          placeholder="输入点位ID，逗号分隔（例：1,2,3）"
          clearable
          style="width: 420px"
        />
        <el-button type="primary" size="small" icon="el-icon-download" :loading="collectLoading" @click="doCollectBatch">
          批量采集
        </el-button>
        <el-divider direction="vertical" />
        <el-form :inline="true" size="small" style="margin: 0">
          <el-form-item label="batchSize" style="margin-bottom: 0">
            <el-input-number
              v-model="collectAllBatchSize"
              size="small"
              :min="50"
              :max="1000"
              :step="50"
              controls-position="right"
              style="width: 160px"
            />
          </el-form-item>
        </el-form>
        <el-button type="warning" size="small" icon="el-icon-refresh" :loading="collectAllLoading" @click="doCollectAll">
          全量采集
        </el-button>
        <el-button size="small" :disabled="!collectResultJson" @click="collectResultJson = ''">清空结果</el-button>
      </div>
      <pre v-if="collectResultJson" style="margin: 10px 0 0" class="result-block">{{ collectResultJson }}</pre>
    </div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      :permission="permissionList"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @before-open="beforeOpen"
    >
      <table-column-set :THIS_TO_PARENT="this" slot="menuRight" />
      <template slot="menu" slot-scope="{ row }">
        <el-button
          type="text"
          size="small"
          icon="el-icon-download"
          :loading="collectRowLoadingId === row.id"
          :disabled="collectRowLoadingId && collectRowLoadingId !== row.id"
          @click="doCollectRow(row)"
        >
          采集
        </el-button>
        <el-button type="text" size="small" icon="el-icon-cpu" @click="openSimulateDialog(row)" style="color: #e37318">
          集控模拟
        </el-button>
      </template>
      <template slot="currentValueForm">
        <el-radio-group v-if="isBooleanDataType" v-model="booleanCurrentValue" @change="onBooleanValueChange">
          <el-radio :label="'1'">true(1)</el-radio>
          <el-radio :label="'0'">false(0)</el-radio>
        </el-radio-group>
        <el-input-number
          v-else-if="isNumberDataType"
          v-model="numberCurrentValue"
          :controls="false"
          :precision="6"
          style="width: 100%"
          placeholder="请输入数值"
          @change="onNumberValueChange"
        />
        <el-input
          v-else
          v-model.trim="form.currentValue"
          maxlength="128"
          show-word-limit
          placeholder="请输入字符串值"
        />
      </template>
    </avue-crud>
    <el-dialog title="集控模拟" :visible.sync="simulateVisible" width="480px">
      <el-form label-width="96px">
        <el-form-item label="点位标识">
          <el-input :value="simulateForm.tag" disabled />
        </el-form-item>
        <el-form-item label="值类型">
          <el-input :value="simulateForm.dataType" disabled />
        </el-form-item>
        <el-form-item label="当前值">
          <el-radio-group v-if="simulateForm.dataType === 'Boolean'" v-model="simulateBooleanValue">
            <el-radio :label="'1'">True</el-radio>
            <el-radio :label="'0'">False</el-radio>
          </el-radio-group>
          <el-input-number
            v-else-if="simulateForm.dataType === 'Float' || simulateForm.dataType === 'Double'"
            v-model="simulateNumberValue"
            :controls="false"
            :precision="6"
            style="width: 100%"
          />
          <el-input v-else v-model.trim="simulateTextValue" maxlength="128" show-word-limit />
        </el-form-item>
        <el-form-item label="采集时间">
          <el-input value="保存时自动更新为当前时间" disabled />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="simulateVisible = false">取消</el-button>
        <el-button type="primary" @click="submitSimulate">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { getList, add, update, remove, getDetail, updateCurrentValueOnly, collectBatch, collectByPointId, collectAll } from './api'
import { searchTimeConfig } from '@/basic-common/util/common'

export default {
  name: 'system-warning-mechanism',
  mixins: [crudMixins],
  computed: {
    isBooleanDataType() {
      return this.form.dataType === 'Boolean'
    },
    isNumberDataType() {
      return this.form.dataType === 'Float' || this.form.dataType === 'Double'
    }
  },
  data() {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      form: {},
      booleanCurrentValue: '0',
      numberCurrentValue: undefined,
      simulateVisible: false,
      simulateForm: {},
      simulateBooleanValue: '0',
      simulateNumberValue: undefined,
      simulateTextValue: '',
      collectPointIds: '',
      collectLoading: false,
      collectRowLoadingId: null,
      collectAllBatchSize: 500,
      collectAllLoading: false,
      collectResultJson: '',
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        searchMenuSpanSuper: 6,
        searchSize: 'small',
        menu: true,
        addBtn: true,
        editBtn: true,
        delBtn: true,
        viewBtn: true,
        selection: false,
        header: true,
        dialogWidth: '860px',
        column: [
          {
            label: '设备名称',
            prop: 'deviceName',
            minWidth: 140,
            overHidden: true,
            align: 'center',
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false
          },
          {
            label: '设备ID',
            prop: 'deviceId',
            width: 100,
            align: 'center',
            search: true,
            searchSpan: 6,
            type: 'number',
            hide: true,
            rules: [{ required: true, message: '请输入设备ID', trigger: 'blur' }]
          },
          {
            label: '点位标识',
            prop: 'tag',
            width: 140,
            overHidden: true,
            search: true,
            searchSpan: 6,
            rules: [{ required: true, message: '请输入点位标识', trigger: 'blur' }]
          },
          {
            label: '节点ID',
            prop: 'nodeId',
            minWidth: 200,
            overHidden: true,
            search: true,
            searchSpan: 6,
            rules: [{ required: true, message: '请输入节点ID', trigger: 'blur' }]
          },
          {
            label: '描述',
            prop: 'description',
            minWidth: 140,
            overHidden: true,
            search: true,
            searchSpan: 6
          },
          {
            label: '值类型',
            prop: 'dataType',
            width: 100,
            align: 'center',
            search: true,
            searchSpan: 6,
            type: 'select',
            dicData: [
              { label: 'Boolean', value: 'Boolean' },
              { label: 'Float', value: 'Float' },
              { label: 'Double', value: 'Double' },
              { label: 'String', value: 'String' }
            ],
            change: ({ value }) => {
              this.handleDataTypeChange(value)
            },
            rules: [{ required: true, message: '请选择值类型', trigger: 'change' }]
          },
          {
            label: '点位类型',
            prop: 'pointType',
            width: 100,
            align: 'center',
            type: 'select',
            dicData: [
              { label: '设备运行参数', value: 1 },
              { label: '报警信号', value: 2 }
            ],
            search: true,
            searchSpan: 6,
            value: 1,
            rules: [{ required: true, message: '请选择点位类型', trigger: 'change' }]
          },
          {
            label: '当前值',
            prop: 'currentValue',
            width: 100,
            overHidden: true,
            formslot: true,
            formatter: (row, value) => this.formatCurrentValueDisplay(row, value),
            rules: [{ required: true, message: '请输入当前值', trigger: 'blur' }]
          },
          {
            label: '采集时间',
            prop: 'collectTime',
            width: 160,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss'
          },
          {
            ...searchTimeConfig,
            searchValue: [],
            paramsKey: ['startTime', 'endTime'],
            search: true,
            searchSpan: 6
          }
        ]
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.crud && this.$refs.crud.getTableHeight()
      this.$refs.crud && this.$refs.crud.doLayout()
    })
  },
  methods: {
    getCrudExtraTopHeight () {
      const el = this.$refs.extraAboveCrud
      if (!el) return 0
      return el.offsetHeight + 12
    },
    doCollectRow(row) {
      if (!row || !row.id) {
        this.$message.warning('点位ID为空，无法采集')
        return
      }
      this.collectRowLoadingId = row.id
      collectByPointId(row.id)
        .then((res) => {
          const body = (res && res.data) || {}
          const payload = body.data !== undefined ? body.data : body
          this.collectResultJson = JSON.stringify(payload, null, 2)
          this.$message.success(`采集完成：点位ID=${row.id}`)
        })
        .catch((e) => {
          this.$message.error((e && e.message) || '采集失败')
        })
        .finally(() => {
          this.collectRowLoadingId = null
          this.onLoad(this.page, this.query)
        })
    },
    doCollectBatch() {
      if (!this.collectPointIds) {
        this.$message.warning('请输入点位ID（逗号分隔）')
        return
      }
      const normalized = this.collectPointIds
        .replace(/，/g, ',')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
        .join(',')
      if (!normalized) {
        this.$message.warning('请输入有效的点位ID（逗号分隔）')
        return
      }
      this.collectLoading = true
      this.collectResultJson = ''
      collectBatch(normalized)
        .then((res) => {
          const body = (res && res.data) || {}
          const payload = body.data !== undefined ? body.data : body
          this.collectResultJson = JSON.stringify(payload, null, 2)
          const ok = payload && payload.success !== false
          this.$message[ok ? 'success' : 'warning'](ok ? '批量采集完成' : '批量采集部分失败（见结果 errors）')
        })
        .catch((e) => {
          this.$message.error((e && e.message) || '批量采集失败')
        })
        .finally(() => {
          this.collectLoading = false
          // 采集后刷新列表，更新 currentValue/collectTime 展示
          this.onLoad(this.page, this.query)
        })
    },
    doCollectAll() {
      const size = this.collectAllBatchSize || 500
      this.collectAllLoading = true
      this.collectResultJson = ''
      this.$message.info('已开始全量采集，耗时较长请稍候…')
      collectAll(size)
        .then((res) => {
          const body = (res && res.data) || {}
          const payload = body.data !== undefined ? body.data : body
          this.collectResultJson = JSON.stringify(payload, null, 2)
          const ok = payload && payload.success !== false
          this.$message[ok ? 'success' : 'warning'](ok ? '全量采集完成' : '全量采集部分批次失败（见结果 errors）')
        })
        .catch((e) => {
          this.$message.error((e && e.message) || '全量采集失败')
        })
        .finally(() => {
          this.collectAllLoading = false
          this.onLoad(this.page, this.query)
        })
    },
    beforeOpen(done, type) {
      this.openType = type
      if (['edit', 'view'].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig.getDetail(this.form.id).then((res) => {
          this.form = res.data.data || res.data
          this.syncCurrentValueEditors()
          done()
        })
      } else {
        if (!this.form.dataType) {
          this.form.dataType = 'Boolean'
        }
        this.handleDataTypeChange(this.form.dataType)
        done()
      }
    },
    syncCurrentValueEditors() {
      const dt = this.form.dataType
      const currentValue = this.form.currentValue == null ? '' : String(this.form.currentValue)
      if (dt === 'Boolean') {
        this.booleanCurrentValue = currentValue === '1' || currentValue === 'true' ? '1' : '0'
        this.form.currentValue = this.booleanCurrentValue
      } else if (dt === 'Float' || dt === 'Double') {
        const n = Number(currentValue)
        this.numberCurrentValue = Number.isNaN(n) ? undefined : n
      }
    },
    handleDataTypeChange(value) {
      if (value === 'Boolean') {
        this.booleanCurrentValue = this.form.currentValue === '1' || this.form.currentValue === 'true' ? '1' : '0'
        this.form.currentValue = this.booleanCurrentValue
        return
      }
      if (value === 'Float' || value === 'Double') {
        const n = Number(this.form.currentValue)
        this.numberCurrentValue = Number.isNaN(n) ? undefined : n
        this.form.currentValue = this.numberCurrentValue == null ? '' : String(this.numberCurrentValue)
        return
      }
      this.numberCurrentValue = undefined
      this.booleanCurrentValue = '0'
      if (this.form.currentValue == null) {
        this.form.currentValue = ''
      } else {
        this.form.currentValue = String(this.form.currentValue)
      }
    },
    onBooleanValueChange(value) {
      this.form.currentValue = value
    },
    onNumberValueChange(value) {
      this.form.currentValue = value == null ? '' : String(value)
    },
    formatCurrentValueDisplay(row, value) {
      if (row.dataType !== 'Boolean') {
        return value
      }
      const normalized = value == null ? '' : String(value).toLowerCase()
      return normalized === '1' || normalized === 'true' ? 'True' : 'False'
    },
    openSimulateDialog(row) {
      this.simulateForm = { ...row }
      const raw = row.currentValue == null ? '' : String(row.currentValue)
      this.simulateBooleanValue = raw === '1' || raw.toLowerCase() === 'true' ? '1' : '0'
      const n = Number(raw)
      this.simulateNumberValue = Number.isNaN(n) ? undefined : n
      this.simulateTextValue = raw
      this.simulateVisible = true
    },
    getSimulateCurrentValue() {
      const dt = this.simulateForm.dataType
      if (dt === 'Boolean') {
        return this.simulateBooleanValue
      }
      if (dt === 'Float' || dt === 'Double') {
        if (this.simulateNumberValue === undefined || this.simulateNumberValue === null || this.simulateNumberValue === '') {
          return ''
        }
        return String(this.simulateNumberValue)
      }
      return this.simulateTextValue || ''
    },
    getNowDateTimeText() {
      const now = new Date()
      const p = (n) => String(n).padStart(2, '0')
      return `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())} ${p(now.getHours())}:${p(now.getMinutes())}:${p(now.getSeconds())}`
    },
    submitSimulate() {
      const currentValue = this.getSimulateCurrentValue()
      if (currentValue === '') {
        this.$message.warning('请填写当前值')
        return
      }
      const collectTime = this.getNowDateTimeText()
      updateCurrentValueOnly({
        id: this.simulateForm.id,
        currentValue,
        collectTime
      }).then(() => {
        this.$message.success('集控模拟保存成功')
        this.simulateVisible = false
        this.onLoad(this.page, this.query)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.warning-mechanism__collect {
  margin-bottom: 12px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-sizing: border-box;
}
.result-block {
  background: #f5f7fa;
  padding: 12px;
  border-radius: 4px;
  font-size: 12px;
  max-height: 260px;
  overflow: auto;
}
</style>
